var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M373.333,0H138.667c-17.673,0-32,14.327-32,32s14.327,32,32,32h234.667c17.673,0,32-14.327,32-32 S391.006,0,373.333,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M373.333,469.333H138.667c-5.891,0-10.667-4.776-10.667-10.667v-89.28 c-0.001-27.687,11.951-54.026,32.789-72.256l37.824-33.109c4.43-3.883,4.873-10.622,0.99-15.052 c-0.308-0.351-0.639-0.682-0.99-0.99l-37.824-33.109c-20.838-18.23-32.79-44.569-32.789-72.256v-89.28 c0-5.891,4.776-10.667,10.667-10.667h234.667c5.891,0,10.667,4.776,10.667,10.667v89.28c0.001,27.687-11.951,54.026-32.789,72.256 l-37.824,33.109c-4.43,3.883-4.873,10.622-0.99,15.052c0.308,0.351,0.639,0.682,0.99,0.99l37.824,33.109 c20.838,18.23,32.79,44.569,32.789,72.256v89.28C384,464.558,379.224,469.333,373.333,469.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEFF1"
    },
    d: "M149.333,448h213.333v-78.613c-0.026-21.547-9.359-42.033-25.6-56.192l-37.824-33.109 c-13.302-11.636-14.652-31.852-3.016-45.154c0.937-1.071,1.945-2.079,3.016-3.016l37.824-33.109 c16.241-14.159,25.574-34.645,25.6-56.192V64H149.333v78.613c0.026,21.547,9.359,42.033,25.6,56.192l37.824,33.109 c13.296,11.643,14.636,31.86,2.994,45.156c-0.931,1.063-1.931,2.063-2.994,2.994l-37.824,33.131 c-16.241,14.159-25.574,34.645-25.6,56.192V448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M319.189,177.259c-1.649-3.989-5.539-6.591-9.856-6.592H202.667 c-5.891-0.011-10.675,4.757-10.686,10.648c-0.005,2.84,1.123,5.565,3.134,7.571l53.333,53.333c4.165,4.164,10.917,4.164,15.083,0 l53.333-53.333C319.92,185.837,320.838,181.248,319.189,177.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M373.333,448H138.667c-17.673,0-32,14.327-32,32s14.327,32,32,32h234.667c17.673,0,32-14.327,32-32 S391.006,448,373.333,448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M263.168,333.44c-4.214-3.815-10.678-3.655-14.699,0.363l-99.136,99.115V448h213.333v-24.107 L263.168,333.44z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.7270c4d2.svg";
export { ForwardRef as ReactComponent };